import Dispatch from "./client";

const urls = {
  deviceList: {
    url: "/device/list",
    method: "get",
  },
  sharedDeviceList: {
    url: "/device/shared/list",
    method: "get",
  },
  devicePair: {
    url: "/device/pair",
    method: "post",
  },
  deviceFreeze: {
    url: "/device/freeze",
    method: "post",
  },
  deviceFreezeUser: {
    url: "/device/freeze-device",
    method: "post",
  },
  deviceDelete: (id) => {
    return {
      url: `/device/${id}`,
      method: "delete",
    };
  },
	sharedUsers: (id) => ({
		url: `/device/${id}/shared-users`,
		method: 'get'
	}),
	unshareDevice: (id) => ({
		url: `/device/unshare/${id}`,
		method: 'post'
	}),
	shareDevice: {
		url: '/device/share',
		method: 'post'
	},
	shareDeviceActiveEmail: (token) => ({
		url: `/device/share/activeEmail/${token}`,
		method: 'get'
	}),
	shareDeviceVerify: {
		url: '/device/share/verify',
		method: 'post'
	}
};

function api() {
  return {
    getDeviceList: (data) =>
      Dispatch(urls.deviceList, data.params, data.payload, data.options),
    getSharedDeviceList: (data) =>
      Dispatch(urls.sharedDeviceList, data.params, data.payload, data.options),
    postDevicePair: (data) =>
      Dispatch(urls.devicePair, data.params, data.payload, data.options),
    freezeDevice: (data) =>
      Dispatch(urls.deviceFreeze, data.params, data.payload, data.options),
    deviceFreezeUser: (data) =>
      Dispatch(urls.deviceFreezeUser, data.params, data.payload, data.options),
    deleteDevice: (data) =>
      Dispatch(urls.deviceDelete(data.params.id), {}, data.payload, data.options),
		getSharedUsers: (data) =>
			Dispatch(urls.sharedUsers(data.params.id), {}, {}, data.options),
		unshareDevice: (data) => 
			Dispatch(urls.unshareDevice(data.params.id), {}, {}, data.options),
		shareDevice: (data) => 
			Dispatch(urls.shareDevice, data.params, data.payload, data.options),
		shareDeviceActiveEmail: (data) => 
			Dispatch(urls.shareDeviceActiveEmail(data.params.token), {}, {}, data.options),
		shareDeviceVerify: (data) => 
			Dispatch(urls.shareDeviceVerify, data.params, data.payload, data.options)
  };
}

export default api();
